// 🔥 HEARTBEAT: Prove this file is actually loading
console.log('🔥 THINKER FILE LOADED INTO BROWSER — TOP OF FILE RUNNING');

// THINKER Attribution Engine v2.0
(function() {
  'use strict';

  const CONFIG = {
    STORAGE_KEY: 'thinker_utms',
    TARGET_URL: '/products/thinker-fine-art-giclee-print-drop-j000-limited-edition-of-100#fine-art',
    HEADER_OFFSET: 100,
    SCROLL_DELAY: 500,
    DEBUG: true
  };

  // ═══════════════════════════════════════════════════════════
  // DEBUG LOGGER
  // ═══════════════════════════════════════════════════════════

  function log(message, data = null, type = 'info') {
    if (!CONFIG.DEBUG) return;

    const emoji = {
      info: 'ℹ️',
      success: '✅',
      warning: '⚠️',
      error: '❌',
      start: '🚀',
      storage: '📦'
    };

    const prefix = `${emoji[type] || 'ℹ️'} THINKER:`;

    if (data !== null) {
      console.log(prefix, message, data);
    } else {
      console.log(prefix, message);
    }
  }

  // ═══════════════════════════════════════════════════════════
  // LOCALSTORAGE HELPER
  // ═══════════════════════════════════════════════════════════

  const storage = {
    isAvailable: function() {
      try {
        const test = '__test__';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
      } catch (e) {
        log('localStorage unavailable', e, 'error');
        return false;
      }
    },

    get: function(key) {
      if (!this.isAvailable()) return null;
      try {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
      } catch (e) {
        log('Error reading from localStorage', e, 'error');
        return null;
      }
    },

    set: function(key, value) {
      if (!this.isAvailable()) return false;
      try {
        localStorage.setItem(key, JSON.stringify(value));
        return true;
      } catch (e) {
        log('Error writing to localStorage', e, 'error');
        return false;
      }
    }
  };

  // ═══════════════════════════════════════════════════════════
  // UTM CAPTURE
  // ═══════════════════════════════════════════════════════════

  function captureUTMs() {
    log('Checking for UTMs in URL...');

    const params = new URLSearchParams(window.location.search);
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    const utms = {};

    utmKeys.forEach(key => {
      const value = params.get(key);
      if (value) {
        utms[key] = value;
      }
    });

    if (Object.keys(utms).length > 0) {
      log('UTMs detected!', utms, 'success');

      if (storage.set(CONFIG.STORAGE_KEY, utms)) {
        log('UTMs saved to localStorage', utms, 'success');
      } else {
        log('Failed to save UTMs', null, 'error');
      }

      return utms;
    } else {
      log('No UTMs in URL');

      const existing = storage.get(CONFIG.STORAGE_KEY);
      if (existing) {
        log('Loading existing UTMs from storage', existing, 'storage');
      } else {
        log('No UTMs in storage either');
      }

      return existing;
    }
  }

  // ═══════════════════════════════════════════════════════════
  // ANCHOR SCROLL
  // ═══════════════════════════════════════════════════════════

  function scrollToAnchor() {
    const hash = window.location.hash;
    if (!hash) return;

    log('Attempting to scroll to anchor:', hash);

    const targetIds = ['fine-art', 'fine-art-section', 'fine-art-details'];
    let target = null;

    for (let id of targetIds) {
      target = document.getElementById(id);
      if (target) {
        log('Found anchor target:', id, 'success');
        break;
      }
    }

    if (!target) {
      target = document.querySelector('.product-information, h4');
      if (target) log('Using fallback selector', null, 'warning');
    }

    if (target) {
      setTimeout(() => {
        const rect = target.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetTop = rect.top + scrollTop - CONFIG.HEADER_OFFSET;

        window.scrollTo({
          top: targetTop,
          behavior: 'smooth'
        });

        log('Scrolled to target', null, 'success');
      }, CONFIG.SCROLL_DELAY);
    } else {
      log('Anchor target not found', null, 'warning');
    }
  }

  // ═══════════════════════════════════════════════════════════
  // FORCED NAVIGATION
  // ═══════════════════════════════════════════════════════════

  function setupForcedNav() {
    document.addEventListener('click', function(e) {
      const el = e.target.closest('a, button');
      if (!el) return;

      const text = (el.textContent || '').trim().toLowerCase();
      const href = (el.getAttribute('href') || '').trim();

      const isFineArtCTA =
        text.includes('explore the fine art print') ||
        href.includes('/products/thinker-fine-art-giclee-print-drop-j000-limited-edition-of-100');

      if (isFineArtCTA) {
        e.preventDefault();
        e.stopPropagation();
        log('Forcing navigation to Fine Art product', null, 'success');
        window.location.href = CONFIG.TARGET_URL;
      }
    }, true);

    log('Forced navigation handler installed');
  }

  // ═══════════════════════════════════════════════════════════
  // INITIALIZATION
  // ═══════════════════════════════════════════════════════════

  function init() {
    log('═══════════════════════════════════════════', null, 'start');
    log('Initializing Attribution Engine...', null, 'start');
    log('═══════════════════════════════════════════', null, 'start');

    captureUTMs();
    setupForcedNav();
    scrollToAnchor();

    log('═══════════════════════════════════════════', null, 'success');
    log('Attribution Engine Ready!', null, 'success');
    log('═══════════════════════════════════════════', null, 'success');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('pageshow', function() {
    log('Page show event triggered');
    scrollToAnchor();
  });

  window.addEventListener('hashchange', function() {
    log('Hash change detected');
    scrollToAnchor();
  });

})();

console.log('🔥 THINKER FILE REACHED END — SCRIPT FULLY LOADED');
